/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
import { AxiosPromise } from 'axios';

import { baseClientConstructorProps } from 'app/api/apiClient/config';

import { BaseClient, BaseClientConstructorProps, SendRequestPayload } from '../baseClient';
import { 
  BankAccountRequest,
  ListBankTypeRequirementsResponse,
  SuccessResponse,
  LookupAbaResponse
 } from '../types';

  //  PublicPayeeBankAccountsClient
class PublicPayeeBankAccountsClient extends BaseClient {
    constructor(props: BaseClientConstructorProps) {
        super(props);
    }

    readonly listBankTypeRequirements = (): AxiosPromise<ListBankTypeRequirementsResponse> => {
        let url_ = "/api/v1/core/payee/bank_accounts/types";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly validateBankAccount = (payload: BankAccountRequest): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/payee/bank_accounts/validate";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly lookupAba = (id: number): AxiosPromise<LookupAbaResponse> => {
        let url_ = "/api/v1/core/payee/bank_accounts/aba/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }
}
// PublicPayeeBankAccountsClient
  
export const publicPayeeBankAccountsClient = new PublicPayeeBankAccountsClient(baseClientConstructorProps);
